import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '服务导航',
    links: [
      { label: '娱乐平台', path: '/category/entertainment' },
      { label: '资讯服务', path: '/category/news' },
      { label: '在线购物', path: '/category/shopping' },
      { label: '社交互动', path: '/category/social' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '用户协议', path: '/' },
      { label: '隐私政策', path: '/' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问题', path: '/#faq' },
      { label: '会员权益', path: '/#member' },
      { label: '意见反馈', path: '/about#contact' },
      { label: '安全中心', path: '/' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="font-heading text-xl font-bold text-background-50 whitespace-nowrap cursor-pointer">
                亚洲<span className="text-primary-400">在线</span>
              </Link>
              <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
                亚洲数字生活一站式平台。覆盖娱乐、资讯、购物、社交等多元场景，为亚洲用户提供流畅、安全、本地化的在线体验。
              </p>
              <div className="flex gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer" aria-label="邮箱">
                  <i className="ri-mail-line text-base"></i>
                </a>
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-background-50 mb-4">{group.title}</h4>
                <ul className="space-y-3">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 亚洲在线 taokep.cn 版权所有
            </p>
            <p className="text-xs text-foreground-500">
              京ICP备2026080001号 | 京公网安备 11010802000001号
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}